import { render, staticRenderFns } from "./WhatsappComparison.vue?vue&type=template&id=e4479ccc&scoped=true"
import script from "./WhatsappComparison.vue?vue&type=script&lang=js"
export * from "./WhatsappComparison.vue?vue&type=script&lang=js"
import style0 from "./WhatsappComparison.vue?vue&type=style&index=0&id=e4479ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4479ccc",
  null
  
)

export default component.exports